import { DateTime } from 'luxon';
import React from 'react';
import { UserTimeFormat } from 'types/user';
import { readOrInferUserTimeFormat } from 'utils/user';
import styles from './PublicReportLiveBanner.module.scss';

interface Props {
  live: boolean;
  timestamp?: string;
}

const PublicReportLiveBanner: React.FC<Props> = ({ live, timestamp }) => {
  const userTimeFormat = readOrInferUserTimeFormat();
  const dtTimestamp = timestamp ? DateTime.fromISO(timestamp) : null;

  const publishedText = dtTimestamp
    ? `Report published at ${dtTimestamp.toLocaleString(
        userTimeFormat === UserTimeFormat.H24 ? DateTime.TIME_24_SIMPLE : DateTime.TIME_SIMPLE
      )} on ${dtTimestamp.toLocaleString(DateTime.DATE_MED)}`
    : null;

  const text = live ? 'This is a live report – refresh to see the latest data.' : publishedText;

  return <div className={styles.container}>{text}</div>;
};

export default React.memo(PublicReportLiveBanner);
